import { StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { StoryData } from '@storyblok/react'
import { wrappedStoryblokComponents } from '../../data-maps/organism-storyblok-components-map'

export interface FinanceOffersCarouselReferenceProps {
  financeOffersCarousel: StoryData[]
  financeRepresentativeExample: StoryData[]
}

export function FinanceOffersCarouselReference({
  financeOffersCarousel,
  financeRepresentativeExample,
}: FinanceOffersCarouselReferenceProps) {
  return (
    <StoryblokRenderer
      block={financeOffersCarousel[0]?.content}
      components={wrappedStoryblokComponents}
      props={{ financeRepresentativeExample }}
    />
  )
}
